import { render, staticRenderFns } from "./MineOrderItem.vue?vue&type=template&id=3b79c4e6&scoped=true"
import script from "./MineOrderItem.vue?vue&type=script&lang=js"
export * from "./MineOrderItem.vue?vue&type=script&lang=js"
import style0 from "./MineOrderItem.vue?vue&type=style&index=0&id=3b79c4e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b79c4e6",
  null
  
)

export default component.exports